<template>
  <div>
    <div class="actions row col-lg-12 mb-5 p-0 m-0 justify-content-end">
      <div class="actions-right row col-lg-6 row justify-content-end p-0 m-0">
        <button type="button" class="btn btn-primary" @click="ADD_ACTION">{{ $t('add') }}</button>
      </div>
    </div>
    <SearchBar @search-clicked="searchClicked"></SearchBar>
    <CTableWrapper ref="table" hover striped :caption="caption" :items="items" :actions="actions" :pages="pages" :fields="fields" clickable-rows @row-clicked="rowClicked" @action-clicked="actionClicked" @update-requested="updateItemsRequested" :sorter="{external: true}" :sorterValue="sorterValue" @sorter-value-changed="sorterValueChanged" :loading="loading">
    </CTableWrapper>
    <ReviewsPopUp v-if="showReviewsPopup" :productId="productId" @closeConfirmRequested="showReviewsPopup = false" v-model="showReviewsPopup"></ReviewsPopUp>

  </div>
</template>
 
<script>
import { mapState, mapActions } from 'vuex'
import CTableWrapper from '@/controls/PaginatedTable.vue'
import SearchBar from '@/controls/SearchBar.vue'
import ReviewsPopUp from '@/controls/popups/ReviewsPopUp.vue'
import router from '@/router';
import InputGetList from "@/classes/InputGetList";
import i18n from '@/helpers/i18n';
import { convertToPascalCase } from "@/helpers/utils.js";

export default {
  components: { CTableWrapper, SearchBar, ReviewsPopUp},
  data () {
    return {
      currentPage: 1,
      showReviewsPopup: false,
      searchText: '',
      caption: i18n.t('products'),
      itemsPerPage: localStorage.itemsPerPage ?? 10,
      fields: [
          { key: 'id', label: i18n.t('id'), _classes: 'font-weight-bold', sortable: true },
          { key: 'title', label: i18n.t('name'), _classes: 'font-weight-bold', sortable: true },
      ],
      actions: [
        { key: 'view', label: i18n.t('view') },
        { key: 'remove', label: i18n.t('remove') }
      ],
      sorterValue: { column: 'id', asc: true },
      loading: false,
      productId: null
    }
  },
  computed: {
    ...mapState('products', ['getProductsOutput']),
    ...mapState('products', ['deleteProductByIdOutput']),
    ...mapState('products', ['addPromotionBannerOutput']),
    ...mapState('products', ['removePromotionBannerOutput']),
    ...mapState('products', ['getProductsReviewsOutput']),

    productInfo: function() {
      return this.getProductsOutput && this.getProductsOutput.data ? this.getProductsOutput.data : null;
    },

    items: function()
    {
      var result = [];

      if(this.productInfo)
      {
        result = this.productInfo;

        result.forEach(product => {

          // Actions
          product["actions"] = [ { key: 'view', label: i18n.t('view') }, { key: 'showReviews', label: i18n.t('showReviews') }];
          if(product.banner == true)
          {
           product["actions"].push({ key: 'removePromotionBanner', label: i18n.t('removePromotionBanner') });          
          }
          else{
           product["actions"].push({ key: 'addPromotionBanner', label: i18n.t('addPromotionBanner') });          
          }
          product["actions"].push({ key: 'remove', label: i18n.t('remove') })
        });
      }

      return result;
    },
    pages: function()
    {
      return this.getProductsOutput ? this.getProductsOutput.totalPages : 1;
    }
  },
  mounted: function()
  {
    this.updateItemsRequested(1, this.itemsPerPage);
  },
  methods: {
    ...mapActions('products', ['getProducts']),
    ...mapActions('products', ['deleteProductById']),
    ...mapActions('products', ['addPromotionBanner']),
    ...mapActions('products', ['removeCurrentProductBanner']),
    rowClicked (item, index) {
        this.$router.push({ name: "ProductEdit", query: { id: item.id }, params: { name: item.name } });
    },
    actionClicked(item, action){
      switch(action.key)
      {
        case 'view':
        {
          this.$router.push({ name: "ProductEdit", query: { id: item.id }, params: { name: item.name } });
          break;
        }
        case 'addPromotionBanner':
        {
          if(confirm(this.$i18n.tc('confirmAddPromotionBanner', item.name, { name: item.name }))){
            this.addPromotionBanner(item.id);
          }
          break;
        }
        case 'removePromotionBanner':
        {
          if(confirm(this.$i18n.tc('removePromotionBanner', item.name, { name: item.name }))){
            this.removeCurrentProductBanner();
          }
          break;
        }
        case 'showReviews':
        {
          this.productId = item.id;
          this.showReviewsPopup = true;
          
          break;
        }
        case 'remove':
        {
          if(confirm(this.$i18n.tc('confirmRemove', item.title, { name: item.title }))){
            this.deleteProductById(item.id);
          }
          break;
        }
        default:
        {
          throw "The provided action is not supported!"; 
        }
      }
    },
    updateItemsRequested(currentPage, itemsPerPage)
    {
      //Make request
      this.loading = true;
      this.itemsPerPage = itemsPerPage;
      this.currentPage = currentPage;

      var input = new InputGetList(itemsPerPage, currentPage, this.searchText, this.sorterValue.asc ? 1 : 2, convertToPascalCase(this.sorterValue.column));

      // List specific parameters
      if(this.$route.params.type)
      {
        input.type = this.$route.params.type;
      }
      
      this.getProducts(input); 
    },
    ADD_ACTION () 
    {
      router.push({ name: 'ProductAdd', params: { type: this.$route.params.type }});
    },
    searchClicked(searchText)
    {
      this.searchText = searchText;
      this.$refs.table.reset();

      this.updateItemsRequested(1, this.itemsPerPage);
    },
    sorterValueChanged(value)
    {
      this.sorterValue = value;
    }    
  },
  watch:
  {
    sorterValue:
    {
      handler: function(val)
      {
        this.updateItemsRequested(1, this.itemsPerPage);
      },
      deep: true // Watch for changes on the properties
    },
    deleteProductByIdOutput: function(val)
    {
      this.loading = true;

      if(val)
      {
        this.updateItemsRequested(this.currentPage, this.itemsPerPage);
      }
    },
    addPromotionBannerOutput: function(val)
    {
      this.loading = true;

      if(val)
      {
        this.updateItemsRequested(this.currentPage, this.itemsPerPage);
      }
    },
    removePromotionBannerOutput: function(val)
    {
      this.loading = true;

      if(val)
      {
        this.updateItemsRequested(this.currentPage, this.itemsPerPage);
      }
    },
    getProductsOutput: function(val)
    {
      if(val != null)
      {
        this.loading = false;
      }
    }
  }
}
</script>

 
<style>
th
{
  border-top: none !important;
}

tr
{
  cursor: pointer;
}

.status-button
{
  border: none;
  padding: 0;
  text-decoration: underline;
  color: #321fdb;
}
</style> 